// export enum EventState {
//   InPreparation,
//   Prepared,
//   InProgress,
//   Completed,
//   Cancelled,
// }

import { useI18n } from "vue-i18n";

interface EventStateParams {
  value: string;
  color: string;
  lightColor: string;
}

export class EventState {
  value: string;
  color: string;
  lightColor: string;

  static events: EventState[] = [
    new EventState({
      value: "NotStarted",
      color: "#2563EB",
      lightColor: "#EFF4FF",
    }),
    new EventState({
      value: "InPreparation",
      color: "#CA8A04",
      lightColor: "#FEF9C3",
    }),
    new EventState({
      value: "Prepared",
      color: "#D97706",
      lightColor: "#FEF3E2",
    }),
    new EventState({
      value: "InExecution",
      color: "#7C3AED",
      lightColor: "#F4EEFE",
    }),
    new EventState({
      value: "Concluded",
      color: "#0D9488",
      lightColor: "#E6F5F3",
    }),
    new EventState({
      value: "Canceled",
      color: "#fb2c36 ",
      lightColor: "#ffc9c9",
    }),
  ];

  constructor({ value, color, lightColor }: EventStateParams) {
    this.value = value;
    this.color = color;
    this.lightColor = lightColor;
  }

  static getEventStateByValue(value: string): EventState {
    switch (value) {
      case EventState.events[0].value:
        return EventState.events[0];
      case EventState.events[1].value:
        return EventState.events[1];
      case EventState.events[2].value:
        return EventState.events[2];
      case EventState.events[3].value:
        return EventState.events[3];
      case EventState.events[4].value:
        return EventState.events[4];
      case EventState.events[5].value:
        return EventState.events[5];
      default:
        throw new Error("Value is out range of EventState");
    }
  }

  getLocalization(): string {
    const { t } = useI18n();
    switch (this.value) {
      case EventState.events[0].value:
        return t("events.list.states.notStarted");
      case EventState.events[1].value:
        return t("events.list.states.inPreparation");
      case EventState.events[2].value:
        return t("events.list.states.prepared");
      case EventState.events[3].value:
        return t("events.list.states.inProgress");
      case EventState.events[4].value:
        return t("events.list.states.completed");
      case EventState.events[5].value:
        return t("events.list.states.cancelled");
      default:
        return this.value;
    }
  }
}
